// Please run unit tests if you change logic

export function filter( input: string, chars: string, invert: boolean = false ): string {
	if ( input == undefined ) return input;
	const regEx = new RegExp( "[" + ( invert ? "^" : "" ) + chars + "]", "g" );
	return input.replace( regEx, "" );
}

export function filterCharSet( input: string, invert: boolean, ...charsets: CharSetProvider[] ): string {
	const charset = charsets.reduce( ( previousValue, currentValue ) => {
		return previousValue + currentValue();
	}, "" );
	return filter( input, charset, invert );
}

export interface CharSetProvider {
	(): string;
}

export const NumberChars: CharSetProvider = () => {
	return "0-9";
};
export const EnglishChars: CharSetProvider = () => {
	return "a-zA-Z";
};

export const ArabicChars: CharSetProvider = () => {
	return "\\u0600-\\u06ff";
};

export const SpaceChars: CharSetProvider = () => {
	return "\\s";
};

export const PunctuationsChars: CharSetProvider = () => {
	return ".,\\/#!$%\\^&\\*;:{}=\\-_`~()";
};


export function convertToSqFt( sqmt: number ): number {
	let sqft = 0.0;
	sqft = sqmt * 10.764;
	return Number( sqft.toFixed( 2 ) );
}

export function convertToSqMt( sqft: number ): number {
	let sqmt = 0.0;
	sqmt = sqft / 10.764;
	return Number( sqmt.toFixed( 2 ) );
}
